import { defineMessages } from "react-intl";

export const messages = defineMessages({
    titleForAdd: {
        id: "addBoundaryToPortal.titleForAdd",
        defaultMessage: "Add Field to JD Ops Center",
    },
    titleForUnarchive: {
        id: "addBoundaryToPortal.titleForUnarchive",
        defaultMessage: "Unarchive Field in JD Ops Center",
    },
    fieldHasNoConflictsOrMatches: {
        id: "addBoundaryToPortal.fieldHasNoConflicts",
        defaultMessage: "No overlapping Fields detected for same Customer in JD Ops Center.",
    },
    fieldHasNoConflictsOrMatchesButIsArchived: {
        id: "addBoundaryToPortal.fieldHasNoConflictsButIsArchived",
        defaultMessage: "This Field already exists in JD Ops Center, but is archived.",
    },
    newClientFieldHasNoConflictsOrMatches: {
        id: "addBoundaryToPortal.newClientFieldHasNoConflicts",
        defaultMessage: "No significant boundary overlap detected in JD Ops Center.",
    },
    wantToAddField: {
        id: "addBoundaryToPortal.wantToAddField",
        defaultMessage: "Would you like to add this Field to JD Ops Center?",
    },
    wantToUnarchiveField: {
        id: "addBoundaryToPortal.wantToUnarchiveField",
        defaultMessage: "Would you like to unarchive it?",
    },
});
